import React from 'react'
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material'
import { GuidanceDetailData } from '@/apps/legacy/features/guidance/types/guidanceTypes'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

type Props = {
  detailData: GuidanceDetailData
}

const GuidanceDetailTab: React.FC<Props> = ({ detailData }) => {
  return (
    <Box sx={{ p: 3 }}>
      {detailData.detail_items.map((item, index) => (
        <Box
          key={index}
          sx={[
            index < detailData.detail_items.length - 1
              ? {
                  mb: 3,
                }
              : {
                  mb: 0,
                },
          ]}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: colorTokens.text.primary,
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              '&::before': {
                content: '"●"',
                color: colorTokens.blue[600],
                marginRight: '8px',
              },
            }}
          >
            {item.label}
          </Typography>
          <List dense disablePadding>
            {item.details.map((detail, detailIndex) => (
              <ListItem
                key={detailIndex}
                sx={{
                  pl: 3,
                  py: 0.5,
                }}
              >
                <ListItemText
                  primary={detail}
                  primaryTypographyProps={{
                    lineHeight: 1.6,
                    color: colorTokens.grey[800],
                  }}
                  sx={{
                    '&::before': {
                      content: '"•"',
                      position: 'absolute',
                      left: '16px',
                      color: colorTokens.text.secondary,
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Box>
  )
}

export default GuidanceDetailTab
